export enum AuctionCode {
  // 付款方式
  PAYMENT_METHOD = 'PAYMENT_METHOD',

  // 交货方式
  DELIVERY_METHOD = 'DELIVERY_METHOD',

  // 房屋用途
  HOUSE_PURPOSE = 'HOUSE_PURPOSE',

  // 房屋产权
  HOUSE_PROPERTY_RIGHT = 'HOUSE_PROPERTY_RIGHT',

  // 有效期类型
  VALID_DATE_TYPE = 'VALID_DATE_TYPE',

  // 指标参数运算类型
  QUOTA_OPERATION_TYPE = 'QUOTA_OPERATION_TYPE'
}
